import React from 'react';
import palette from '../themes/zizzi/color-palette';

interface RightArrowProps {
  fill?: string;
}

const RightArrow = ({ fill = palette.common.white }: RightArrowProps) => (
  <svg width="10" height="13" viewBox="0 -3 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.00065 0.833008L4.17815 1.65551L7.43315 4.91634H0.333984V6.08301H7.43315L4.17815 9.34384L5.00065 10.1663L9.66732 5.49967L5.00065 0.833008Z"
      fill={fill}
    />
  </svg>
);

export default RightArrow;
